import { ClipboardList, ListChecks, Handshake, Lock } from "lucide-react";

const NAVY = "#010082";

export const LISTING_TABS = [
  { id: "intake", label: "Intake", icon: ClipboardList },
  { id: "deadlines", label: "7-Phase MLS Deadlines", icon: ListChecks },
  { id: "transaction", label: "Transaction Hub", icon: Handshake },
];

export function isTransactionHubUnlocked(listing) {
  const t = listing?.tasks || {};
  return !!(t.t6_acceptance && t.t6_acceptance.done);
}

export default function ListingTabs({ active, onChange, listing }) {
  const hubUnlocked = isTransactionHubUnlocked(listing);
  return (
    <div
      className="mb-8 border-b border-stone-200 flex items-center gap-1 overflow-x-auto"
      role="tablist"
      data-testid="listing-tabs"
    >
      {LISTING_TABS.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.id;
        const locked = t.id === "transaction" && !hubUnlocked;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(t.id)}
            data-testid={`listing-tab-${t.id}`}
            className={`relative inline-flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors ${
              isActive
                ? "text-stone-900"
                : locked
                ? "text-stone-400 hover:text-stone-500"
                : "text-stone-500 hover:text-stone-800"
            }`}
          >
            <Icon className="h-4 w-4" />
            {t.label}
            {locked && <Lock className="h-3 w-3 text-stone-400" />}
            {isActive && (
              <span
                className="absolute left-0 right-0 -bottom-px h-0.5 rounded-full"
                style={{ backgroundColor: NAVY }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
